export default __webpack_public_path__ + "static/media/ureg.4f0bfe7d.png";